import React, { useCallback, useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { iconList } from 'assets/newAssets/SVG/additionalIconsForLinks/iconList';
import { v4 as uuidv4 } from 'uuid';
import RGL, { WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import { useSearchParams } from 'react-router-dom';

import CustomReportSection from './CustomReportSection';
import {
  useDeleteSection,
  useGetCustomReportPublishedData,
  useGetCustomReportSections,
  useSaveNewSection,
  useSaveNewSectionItem,
  useUpdateSection,
} from './CustomReportsHooks/useCustomReportsGrid';
import { useGetSavedText, useSaveCustomReportText } from './CustomReportsHooks/useCustomReportsText';
import { useGetKPIValues, useSaveCustomReportKPI } from './CustomReportsHooks/useCustomReportsKPI';
import { useGetStoredQuery, useSaveCustomReportQuery } from './CustomReportsHooks/useCustomReportsQueries';
import { useGetStoredFile } from './CustomReportsHooks/useCustomReportsFile';
import { useGetStoredCreative, useSaveCustomReportCreative } from './CustomReportsHooks/useCustomReportsCreative';
import { saveFiletoS3 } from '../Main/Brief/UploadFile/saveFiletoS3';
import { DeleteCustomReportMutation, DeleteCustomReportMutationVariables, SectionGridLayout, UserQuery } from 'API';
import { useCustomReportContext } from 'context/CustomReportContext';
import APIContext from 'context/APIContext';
import { DarkButton, IconButton } from 'components/style/Global';
import { IconButtonContainer } from 'components/Header/Header.styled';
import AddCustomReport from '../AddCustomReport';
import DuplicateCustomReportModal from '../DuplicateCustomReportModal';
import { API } from 'aws-amplify';
import { deleteCustomReport } from 'graphql/mutations';
import DeleteConfirmationModal from 'components/DeleteConfirmationModall';
import { createPortal } from 'react-dom';
import { TxtContainer } from 'components/Main/Main.styles';
import ReactLoading from 'react-loading';
const ReactGridLayout = WidthProvider(RGL);

export const CustomReportContainer = styled.div`
  box-shadow: 0 0 0 8000px rgba(0, 0, 0, 0.7);
  padding: 20px 30px;
  z-index: 100;
  min-height: 100%; /* 100% Full-height */
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: ${({ theme }) => theme.placeholderBackground};
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
  gap: 40px;
  background: linear-gradient(135deg, ${({ theme }) => theme.background} 0%, ${({ theme }) => theme.background}F8 100%);
  backdrop-filter: blur(1px);
  .icon {
    padding: 1px;
    font-weight: 400;
    font-size: 20px;
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    margin-bottom: 8px;

    .headerContent {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 32px;
      flex: 1;

      .title {
        h1 {
          font-size: clamp(1.25rem, 2vw, 1.6rem);
          font-weight: 600;
          color: ${({ theme }) => theme.primaryGray};
          margin: 0;
          line-height: 1.2;
          letter-spacing: -0.02em;
        }
      }
    }

    .actions {
      display: flex;
      align-items: center;

      .divider {
        width: 1px;
        height: 20px;
        background: ${({ theme }) => theme.border};
        margin: 0 8px;
      }

      .published-date {
        font-size: 11px;
        color: ${({ theme }) => theme.secondaryGray};
        margin-left: 8px;
      }
    }

    .close-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px;
      background: transparent;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      box-shadow: none;
      color: ${({ theme }) => theme.secondaryGray};
      margin-left: 16px;

      &:hover {
        background: ${({ theme }) => theme.c50};
        box-shadow: none;
      }

      .material-symbols-outlined {
        font-size: 20px;
      }
    }
  }
  .section {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 40px;
    height: fit-content;
    padding: 16px;
    background: linear-gradient(
      135deg,
      ${({ theme }) => theme.background}F8 0%,
      ${({ theme }) => theme.background} 100%
    );
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.border}20;
  }
  .layout {
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0;
    padding-bottom: 100px;
    gap: 11px;
    .grid-item {
      background: linear-gradient(
        135deg,
        ${({ theme }) => theme.placeholderBackground} 0%,
        ${({ theme }) => theme.placeholderBackground}F0 100%
      );
      /* border: 1px solid ${({ theme }) => theme.border}; */
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2rem;
      color: ${({ theme }) => theme.primaryGray};
      font-weight: bold;
      box-shadow:
        0 1px 4px rgba(0, 0, 0, 0.02),
        0 1px 2px rgba(0, 0, 0, 0.04);
      transition: all 0.2s ease;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent 0%, ${({ theme }) => theme.border}60 50%, transparent 100%);
      }

      &:hover {
        outline: 1px solid ${({ theme }) => theme.primaryGray}40;
        box-shadow:
          0 2px 6px rgba(0, 0, 0, 0.03),
          0 1px 3px rgba(0, 0, 0, 0.05);
        transform: translateY(-1px);
        border-color: ${({ theme }) => theme.border}80;
      }
    }
  }
  .actionContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    padding: 2px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: ${({ theme }) => theme.placeholderBackground};
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

    &:hover {
      background: ${({ theme }) => theme.c50};
      border-color: ${({ theme }) => theme.c100};
      transform: scale(1.05);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    }

    span {
      font-size: 16px;
      line-height: 1;
    }

    /* Ukloni ::after jer nema prostora za tekst */
    &::after {
      display: none;
    }
  }

  .delete-btn {
    &:hover {
      background-color: ${({ theme }) => theme.brand};
      border-color: ${({ theme }) => theme.brand};
      color: white;
    }
  }
  .grid-section {
    /* border: 1px solid ${({ theme }) => theme.border}; */
    border-radius: 12px;
    /* background: linear-gradient(
      135deg,
      ${({ theme }) => theme.placeholderBackground} 0%,
      ${({ theme }) => theme.placeholderBackground}F5 100%
    ); */
    background-color: ${({ theme }) => theme.scrollThumb}F5;
    box-shadow:
      0 2px 12px rgba(0, 0, 0, 0.04),
      0 1px 4px rgba(0, 0, 0, 0.08);
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
    padding: 10px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(
        90deg,
        transparent 0%,
        ${({ theme }) => theme.border}40 20%,
        ${({ theme }) => theme.border}80 50%,
        ${({ theme }) => theme.border}40 80%,
        transparent 100%
      );
    }

    &:hover {
      box-shadow:
        0 3px 16px rgba(0, 0, 0, 0.06),
        0 2px 6px rgba(0, 0, 0, 0.08);
      transform: translateY(-1px);
      border-color: ${({ theme }) => theme.border}60;

      .edit-section-btns {
        display: flex;
        flex-direction: row;
        gap: 5px;
        background-color: transparent;
      }
    }

    .edit-section-btns {
      display: flex;
      position: relative;
      z-index: 10000;
      pointer-events: all;
      .edit-section-btn {
        font-weight: 300;
        box-shadow:
          0 2px 8px rgba(0, 0, 0, 0.1),
          0 1px 3px rgba(0, 0, 0, 0.08);
        border-radius: 50%;
        cursor: pointer;
        padding: 6px;
        transition: all 0.2s ease;
        background: ${({ theme }) => theme.c50};
        color: ${({ theme }) => theme.brand};
        border: 1px solid ${({ theme }) => theme.c100}40;

        &:hover {
          outline: 1px solid ${({ theme }) => theme.c200};
          box-shadow:
            0 3px 12px rgba(0, 0, 0, 0.15),
            0 2px 6px rgba(0, 0, 0, 0.1);
          transform: scale(1.05);
          background: ${({ theme }) => theme.c100};
        }
      }
    }
  }
  .toast {
    position: fixed;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: linear-gradient(
      135deg,
      ${({ theme }) => theme.background} 0%,
      ${({ theme }) => theme.background}F8 100%
    );
    padding: 24px;
    border-radius: 12px;
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.12),
      0 4px 16px rgba(0, 0, 0, 0.08);
    z-index: 1000;
    border: 1px solid ${({ theme }) => theme.border}40;
    backdrop-filter: blur(8px);

    .toast-content {
      display: flex;
      flex-direction: column;
      gap: 16px;

      p {
        margin: 0;
        color: ${({ theme }) => theme.primaryGray};
        font-weight: 400;
      }

      .buttons {
        display: flex;
        flex-direction: row;
        gap: 12px;
        justify-content: center;
      }
    }
  }
  .published-date {
    font-size: 12px;
    color: ${({ theme }) => theme.primaryGray};
    margin-left: 8px;
    padding: 4px 8px;
    background-color: ${({ theme }) => theme.c50};
    border-radius: 4px;
    white-space: nowrap;
  }
`;

// PowerPoint-style presentation components
export const PresentationContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const SlideViewport = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const SlideDisplay = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;

  .current-slide {
    width: 100%;
    height: fit-content;
    animation: slideIn 0.3s ease-out;
  }

  /* Preserve original ReactGridLayout styling for proper grid alignment */
  .layout {
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0;
    padding-bottom: 100px;
    gap: 11px;
  }

  .grid-section {
    position: relative;
    width: 100%;
    height: fit-content;
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export const SlideControls = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(8px);
  z-index: 1000;

  .slide-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: ${({ theme }) => theme.secondaryGray};
    padding: 0 8px;

    .current-slide-number {
      font-weight: 600;
      color: ${({ theme }) => theme.primaryGray};
    }
  }
`;

export const NavigationSidebar = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  right: ${({ isVisible }) => (isVisible ? '0' : '-300px')};
  width: 300px;
  height: 100vh;
  background: ${({ theme }) => theme.background};
  border-left: 1px solid ${({ theme }) => theme.border};
  z-index: 1000;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);

  .sidebar-header {
    padding: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      color: ${({ theme }) => theme.primaryGray};
    }
  }

  .sidebar-content {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
`;

export const SlideThumbnail = styled.div<{ isActive: boolean; isDragging?: boolean; isDraggedOver?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background: ${({ theme }) => theme.placeholderBackground};
  border: 2px solid
    ${({ isActive, isDragging, isDraggedOver, theme }) => {
      if (isDraggedOver) return theme.publishButton + '80';
      if (isDragging) return theme.primaryGray + '60';
      if (isActive) return theme.publishButton;
      return theme.border;
    }};
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};
  transition: all 0.2s ease;
  overflow: hidden;
  opacity: ${({ isDragging }) => (isDragging ? 0.6 : 1)};
  transform: ${({ isDraggedOver }) => (isDraggedOver ? 'scale(1.02)' : 'scale(1)')};

  &:hover {
    border-color: ${({ theme }) => theme.primaryGray}60;
  }

  .thumbnail-content {
    width: 100%;
    height: 100%;
    transform: scale(0.15);
    transform-origin: top left;
    position: absolute;
    pointer-events: none;
  }

  .thumbnail-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
    color: white;
    padding: 8px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .slide-number {
      flex: 1;
    }

    .action-btn {
      background: ${({ theme }) => theme.c50};
      border: 1px solid ${({ theme }) => theme.c100}40;
      border-radius: 4px;
      color: ${({ theme }) => theme.brand};
      padding: 4px 6px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      &:hover {
        background: ${({ theme }) => theme.c100};
        border-color: ${({ theme }) => theme.c200};
        transform: scale(1.05);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
      }

      .material-symbols-outlined {
        font-size: 14px;
      }
    }

    .action-btn.delete:hover {
      background: ${({ theme }) => theme.brand};
      color: white;
      border-color: ${({ theme }) => theme.brand};
    }
  }
`;

export const LegacyGridContainer = styled.div`
  /* Legacy grid layout styles preserved for fallback */
`;

const CustomReportTab = () => {
  const [fetchCustomReportSections] = useGetCustomReportSections();
  const [searchParams, setSearchParams] = useSearchParams();
  const closeIcon = iconList.find((icon) => icon === 'close');
  const theme = useTheme();
  const { getEnvironment } = React.useContext(APIContext);
  const {
    sectionLayoutState,
    safeSectionLayoutUpdate,
    activeCustomReport,
    handlePublishCustomReport,
    handleUnPublishCustomReport,
  } = useCustomReportContext();

  // Legacy grid mode state (now unused)
  const [saveNewSection] = useSaveNewSection();
  const [saveNewSectionItem] = useSaveNewSectionItem();
  const [updateSection] = useUpdateSection();

  // Content hooks for duplicating
  const [getSavedText] = useGetSavedText();
  const [saveText] = useSaveCustomReportText();
  const [getKPIValues] = useGetKPIValues();
  const [saveKPI] = useSaveCustomReportKPI();
  const [getStoredQuery] = useGetStoredQuery();
  const [saveQuery] = useSaveCustomReportQuery();
  const [getStoredFile] = useGetStoredFile();
  const [getStoredCreative] = useGetStoredCreative();
  const [saveCreative] = useSaveCustomReportCreative();

  const [editModal, setEditModal] = useState(false);
  const [duplicateModal, setDuplicateModal] = useState(false);
  const userIsAuthorized = activeCustomReport?.authorized;
  const [showDeleteSectionModal, setShowDeleteSectionModal] = useState(false);
  const [sectionToDelete, setSectionToDelete] = useState<string | null>(null);
  const [isDeletingSection, setIsDeletingSection] = useState(false);

  // Duplicate section state
  const [isDuplicatingSection, setIsDuplicatingSection] = useState(false);
  const [duplicateToast, setDuplicateToast] = useState<{ show: boolean; message: string; type: 'success' | 'error' }>({
    show: false,
    message: '',
    type: 'success',
  });

  // PowerPoint-style presentation mode state (always enabled)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [showNavigationSidebar, setShowNavigationSidebar] = useState(false);
  const keyboardNavigationEnabled = true; // Always enabled

  // Drag and drop state for reordering sections
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

  // Helper function to get next available position for sections
  const getNextAvailablePosition = useCallback((sections: SectionGridLayout[]) => {
    const existingPositions = sections
      .map((s) => s.Position)
      .filter((pos): pos is number => pos !== null && pos !== undefined)
      .sort((a, b) => a - b);
    let nextPosition = 1;
    for (const pos of existingPositions) {
      if (nextPosition === pos) {
        nextPosition++;
      } else {
        break;
      }
    }
    return nextPosition;
  }, []);

  // PowerPoint-style navigation functions
  const navigateToSlide = useCallback(
    (index: number) => {
      if (index >= 0 && index < sectionLayoutState.length) {
        setCurrentSlideIndex(index);
      }
    },
    [sectionLayoutState.length],
  );

  const navigateNext = useCallback(() => {
    const nextIndex = Math.min(currentSlideIndex + 1, sectionLayoutState.length - 1);
    setCurrentSlideIndex(nextIndex);
  }, [currentSlideIndex, sectionLayoutState.length]);

  const navigatePrevious = useCallback(() => {
    const prevIndex = Math.max(currentSlideIndex - 1, 0);
    setCurrentSlideIndex(prevIndex);
  }, [currentSlideIndex]);

  const navigateToFirst = useCallback(() => setCurrentSlideIndex(0), []);
  const navigateToLast = useCallback(
    () => setCurrentSlideIndex(sectionLayoutState.length - 1),
    [sectionLayoutState.length],
  );

  // Drag and drop handlers for reordering sections
  const handleDragStart = useCallback((e: React.DragEvent, index: number) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  }, []);

  const handleDragOver = useCallback((e: React.DragEvent, index: number) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverIndex(index);
  }, []);

  const handleDragLeave = useCallback(() => {
    setDragOverIndex(null);
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent, dropIndex: number) => {
      e.preventDefault();

      if (draggedIndex === null || draggedIndex === dropIndex) {
        setDraggedIndex(null);
        setDragOverIndex(null);
        return;
      }

      const filteredSections = sectionLayoutState
        .filter((item) =>
          !activeCustomReport?.authorized && item.SectionElements ? item.SectionElements?.length > 0 : true,
        )
        .sort((a, b) => (a.Position || 0) - (b.Position || 0));

      // Create new array with reordered sections
      const newSections = [...filteredSections];
      const draggedItem = newSections[draggedIndex];

      // Remove the dragged item and insert it at the new position
      newSections.splice(draggedIndex, 1);
      newSections.splice(dropIndex, 0, draggedItem);

      // Update positions for all sections
      const updatedSections = newSections.map((section, index) => ({
        ...section,
        Position: index + 1,
        SectionPosition: {
          ...section.SectionPosition,
          i: (index + 1).toString(),
          __typename: 'Layout' as const,
        },
      }));

      // Update the layout state
      safeSectionLayoutUpdate(() => {
        const allSections = [...sectionLayoutState];
        updatedSections.forEach((updatedSection, index) => {
          const originalIndex = allSections.findIndex((s) => s.SectionID === updatedSection.SectionID);
          if (originalIndex !== -1) {
            allSections[originalIndex] = updatedSection;
          }
        });
        return allSections;
      });

      // Save changes to API
      const sectionsToUpdate = updatedSections.map((section) => ({
        SectionID: section.SectionID!,
        Position: section.Position!,
        SectionPosition: {
          i: section.SectionPosition?.i!,
          x: section.SectionPosition?.x ?? 0,
          y: section.SectionPosition?.y ?? 0,
          w: section.SectionPosition?.w ?? 1,
          h: section.SectionPosition?.h ?? 1,
        },
        SectionItems:
          section.SectionElements?.map((element) => ({
            SectionItemID: element?.SectionItemID || '',
            SectionItemPosition: {
              Position: element?.Position || 0,
              GridPosition: {
                i: element?.GridPosition?.i || '',
                x: element?.GridPosition?.x || 0,
                y: element?.GridPosition?.y || 0,
                w: element?.GridPosition?.w || 1,
                h: element?.GridPosition?.h || 1,
              },
              Type: element?.Type || '',
              HasData: element?.HasData || false,
              Open: element?.Open || false,
            },
          })) || [],
      }));

      updateSection(sectionsToUpdate).catch((error) => {
        console.error('Error updating section positions:', error);
        // Optionally refresh data from server on error
        if (activeCustomReport?.CustomReportID) {
          fetchCustomReportSections(activeCustomReport.CustomReportID).then((response) => {
            if (response) {
              safeSectionLayoutUpdate(() => response);
            }
          });
        }
      });

      // Adjust current slide index if necessary
      if (draggedIndex < currentSlideIndex && dropIndex >= currentSlideIndex) {
        setCurrentSlideIndex(currentSlideIndex - 1);
      } else if (draggedIndex > currentSlideIndex && dropIndex <= currentSlideIndex) {
        setCurrentSlideIndex(currentSlideIndex + 1);
      } else if (draggedIndex === currentSlideIndex) {
        setCurrentSlideIndex(dropIndex);
      }

      setDraggedIndex(null);
      setDragOverIndex(null);
    },
    [
      draggedIndex,
      sectionLayoutState,
      activeCustomReport?.authorized,
      safeSectionLayoutUpdate,
      currentSlideIndex,
      updateSection,
      fetchCustomReportSections,
      activeCustomReport?.CustomReportID,
    ],
  );

  const handleDragEnd = useCallback(() => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  }, []);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!keyboardNavigationEnabled) return;

      // Ignore keyboard navigation when user is typing in input/textarea fields
      const activeElement = document.activeElement;
      const isInputFocused =
        activeElement instanceof HTMLInputElement ||
        activeElement instanceof HTMLTextAreaElement ||
        activeElement instanceof HTMLSelectElement ||
        activeElement?.getAttribute('contenteditable') === 'true';

      if (isInputFocused) return;

      switch (event.key) {
        case 'ArrowRight':
        case ' ': // Space key
          event.preventDefault();
          navigateNext();
          break;

        case 'ArrowLeft':
          event.preventDefault();
          navigatePrevious();
          break;

        case 'Home':
          event.preventDefault();
          navigateToFirst();
          break;

        case 'End':
          event.preventDefault();
          navigateToLast();
          break;

        case 'Escape':
          event.preventDefault();
          setShowNavigationSidebar(false);
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [keyboardNavigationEnabled, navigateNext, navigatePrevious, navigateToFirst, navigateToLast]);

  // Ensure currentSlideIndex is valid when sections change
  useEffect(() => {
    if (currentSlideIndex >= sectionLayoutState.length && sectionLayoutState.length > 0) {
      setCurrentSlideIndex(sectionLayoutState.length - 1);
    }
  }, [currentSlideIndex, sectionLayoutState.length]);

  const [displayGrid, setDisplayGrid] = useState(true);
  const [deleteSection] = useDeleteSection();
  const handleDeleteSection = async (sectionID: string) => {
    setIsDeletingSection(true);
    try {
      const response = await deleteSection(sectionID);
      if (response === 'success') {
        const sectionsResponse = await fetchCustomReportSections(activeCustomReport?.CustomReportID);
        if (sectionsResponse) {
          safeSectionLayoutUpdate(() => sectionsResponse);
        }
      }
    } catch (error) {
      console.error('Error deleting section:', error);
    } finally {
      setIsDeletingSection(false);
      setShowDeleteSectionModal(false);
      setSectionToDelete(null);
    }
  };

  // Duplicate section handler - copies structure AND content
  // Uses sequential API calls to avoid 429 Too Many Requests
  const handleDuplicateSection = async (sectionToDuplicate: SectionGridLayout) => {
    if (!sectionToDuplicate || !activeCustomReport?.CustomReportID) return;

    setIsDuplicatingSection(true);

    try {
      const originalElements = (sectionToDuplicate.SectionElements || []).filter(Boolean);

      // Step 1: Fetch all content SEQUENTIALLY before creating anything
      const contentData: Array<{
        element: NonNullable<(typeof originalElements)[0]>;
        content: { type: string; data: any } | null;
      }> = [];

      for (const element of originalElements) {
        if (!element?.SectionItemID) {
          contentData.push({ element: element!, content: null });
          continue;
        }

        const type = element.Type?.toUpperCase();
        try {
          if (type === 'TEXT') {
            const text = await getSavedText(element.SectionItemID);
            contentData.push({ element, content: { type: 'TEXT', data: text } });
          } else if (type === 'KPI') {
            const kpiValues = await getKPIValues(element.SectionItemID);
            contentData.push({ element, content: { type: 'KPI', data: kpiValues } });
          } else if (type === 'TABLE' || type === 'CHART' || type === 'KPIQUERY') {
            // TABLE, CHART and KPIQUERY elements use storeQueriesV2
            const query = await getStoredQuery(element.SectionItemID);
            contentData.push({ element, content: { type: 'QUERY', data: query } });
          } else if (type === 'FILE') {
            // Fetch file from S3
            const file = await getStoredFile(element.SectionItemID);
            if (file && file.name) {
              contentData.push({ element, content: { type: 'FILE', data: file } });
            } else {
              contentData.push({ element, content: { type: 'FILE', data: null } });
            }
          } else if (type === 'CREATIVE') {
            // Fetch creative data
            const creativeData = await getStoredCreative(element.SectionItemID);
            if (creativeData) {
              contentData.push({ element, content: { type: 'CREATIVE', data: creativeData } });
            } else {
              contentData.push({ element, content: { type: 'CREATIVE', data: null } });
            }
          } else {
            contentData.push({ element, content: null });
          }
        } catch (e) {
          console.warn(`Failed to fetch content for element ${element.SectionItemID}:`, e);
          contentData.push({ element, content: null });
        }
      }

      // Step 2: Create new section at the end
      const nextPosition = Math.max(...sectionLayoutState.map((s) => s.Position || 0), 0) + 1;
      const newSectionLayout = {
        i: nextPosition.toString(),
        x: sectionToDuplicate.SectionPosition?.x ?? 0,
        y: sectionToDuplicate.SectionPosition?.y ?? 0,
        w: sectionToDuplicate.SectionPosition?.w ?? 1,
        h: sectionToDuplicate.SectionPosition?.h ?? 1,
      };

      const createSectionResponse = await saveNewSection(nextPosition, newSectionLayout);
      if (createSectionResponse !== 'success') {
        throw new Error('Failed to create new section');
      }

      // Step 3: Fetch updated sections to get the new SectionID
      const updatedSections = await fetchCustomReportSections(activeCustomReport.CustomReportID);
      if (!updatedSections) {
        throw new Error('Failed to fetch updated sections');
      }

      const newSection = updatedSections.find((s) => s.Position === nextPosition);
      if (!newSection || !newSection.SectionID) {
        throw new Error('Could not find newly created section');
      }

      // Step 4: Create elements and copy content SEQUENTIALLY
      let skippedFiles = 0;
      for (const { element, content } of contentData) {
        if (!element) continue;

        const newGridId = uuidv4();

        // Create the element structure
        const itemLayout = {
          Position: element.Position || 0,
          GridPosition: {
            i: newGridId,
            x: element.GridPosition?.x || 0,
            y: element.GridPosition?.y || 0,
            w: element.GridPosition?.w || 1,
            h: element.GridPosition?.h || 1,
          },
          Type: element.Type || '',
          HasData: content?.data ? true : false,
          Open: false,
        };

        const itemResponse = await saveNewSectionItem(newSection.SectionID!, itemLayout);
        if (itemResponse.status !== 200 || !itemResponse.id) {
          console.warn('Failed to create element:', itemResponse.message);
          continue;
        }

        const newItemId = itemResponse.id;

        // Copy content based on type
        if (content?.data) {
          try {
            if (content.type === 'TEXT' && typeof content.data === 'string') {
              await saveText(newItemId, content.data);
            } else if (content.type === 'KPI' && Array.isArray(content.data) && content.data.length > 0) {
              const latestKPI = content.data[0];
              if (latestKPI) {
                await saveKPI(newItemId, {
                  value: latestKPI.floatValue ?? 0,
                  labelTitle: latestKPI.label ?? '',
                  labelSubtitle: latestKPI.subtitle ?? '',
                  valueFormat: latestKPI.format ?? 'number',
                });
              }
            } else if (content.type === 'QUERY' && content.data) {
              const queryData = content.data as UserQuery;
              // Map MetricsResponse to MetricsInfo
              const metricsToSave =
                queryData.metrics
                  ?.filter((m): m is NonNullable<typeof m> => m !== null)
                  .map((m) => ({
                    chartType: m.chartType,
                    metric: m.metric,
                    axis: m.axis,
                  })) || undefined;

              await saveQuery(
                newItemId,
                queryData.query_id || '',
                queryData.query_id_cc || '',
                queryData.title || '',
                metricsToSave,
                queryData.query_id_benchmark || undefined,
                queryData.hideTotal ?? undefined,
              );
            } else if (content.type === 'FILE' && content.data instanceof File) {
              // Upload file to S3 with new position ID
              saveFiletoS3(
                content.data,
                newItemId,
                activeCustomReport.CustomReportID,
                activeCustomReport.Client?.Code || '',
                activeCustomReport.Client?.Country || '',
                getEnvironment,
                'CustomReports',
              );
            } else if (content.type === 'CREATIVE' && content.data) {
              // Save creative data
              const creativeData = content.data;
              const creative = creativeData.creative;
              if (creativeData.dataSourceName && creative) {
                const creativeInput = {
                  id: creative.id || '',
                  position: creative.position ?? 0,
                  creativeOutputLocation: creative.creativeOutputLocation || '',
                  creativeID: creative.creativeID || '',
                  creativeName: creative.creativeName || '',
                  metrics:
                    creative.metrics
                      ?.filter((m: any): m is NonNullable<typeof m> => m !== null)
                      .map((m: any) => ({
                        label: m.label || '',
                        column: m.column || '',
                        decimals: m.decimals ?? 2,
                      })) || [],
                };
                await saveCreative(
                  newItemId,
                  creativeData.dataSourceName,
                  [creativeInput],
                  creativeData.title || undefined,
                );
              }
            }
          } catch (e) {
            console.warn(`Failed to copy content for element ${newItemId}:`, e);
          }
        } else if (content?.type === 'FILE' && !content?.data) {
          // Only count as skipped if file data was not retrieved
          skippedFiles++;
        }
      }

      // Step 5: Refresh sections from API
      const finalSections = await fetchCustomReportSections(activeCustomReport.CustomReportID);
      if (finalSections) {
        safeSectionLayoutUpdate(() => finalSections);
      }

      // Show success toast
      const successMsg =
        skippedFiles > 0
          ? `Section duplicated! (${skippedFiles} file(s) need manual re-upload)`
          : 'Section duplicated successfully!';

      setDuplicateToast({
        show: true,
        message: successMsg,
        type: 'success',
      });

      // Navigate to the new section
      const newIndex = finalSections
        ? finalSections
            .filter((item) =>
              !activeCustomReport?.authorized && item.SectionElements ? item.SectionElements?.length > 0 : true,
            )
            .sort((a, b) => (a.Position || 0) - (b.Position || 0))
            .findIndex((s) => s.SectionID === newSection.SectionID)
        : -1;
      if (newIndex !== -1) {
        setCurrentSlideIndex(newIndex);
      }
    } catch (error) {
      console.error('Error duplicating section:', error);
      setDuplicateToast({
        show: true,
        message: 'Failed to duplicate section. Please try again.',
        type: 'error',
      });
    } finally {
      setIsDuplicatingSection(false);
    }
  };

  // Auto-hide duplicate toast
  useEffect(() => {
    if (duplicateToast.show) {
      const timer = setTimeout(() => {
        setDuplicateToast((prev) => ({ ...prev, show: false }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [duplicateToast.show]);

  const [deleteToast, setDeleteToast] = useState(false);
  const handleDeleteCustomReport = async () => {
    try {
      const response = (await API.graphql({
        query: deleteCustomReport,
        variables: {
          ID: activeCustomReport?.CustomReportID,
        } as DeleteCustomReportMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteCustomReportMutation };
      console.log('RESPONSE', response);
      if (response.data?.deleteCustomReport) {
        setSearchParams((prev) => {
          prev.delete('tab');
          prev.delete('customReportID');
          return prev;
        });
        setDeleteToast(false);
        window.location.reload(); // Reload the page to reflect changes
      } else {
        alert('Error deleting custom report');
      }
    } catch (e) {
      console.error('ERROR SAVING CUSTOM REPORT', e);
      alert('Error deleting custom report');
    }
  };
  const [publishedData] = useGetCustomReportPublishedData();
  const [publishedDate, setPublishedDate] = useState<string>('');
  useEffect(() => {
    const fetchPublishedDate = async () => {
      try {
        const data = await publishedData();
        if (data?.publishedAt) {
          setPublishedDate('Published on ' + data.publishedAt.split(' ')[0]);
        }
      } catch (error) {
        console.error('Error fetching published date:', error);
      }
    };

    if (activeCustomReport?.subcampaign[-1]?.published.DIGITAL) {
      fetchPublishedDate();
    }
  }, [activeCustomReport, publishedData]);

  if (!sectionLayoutState || !activeCustomReport) {
    return <></>;
  }

  return (
    <CustomReportContainer>
      <div className="modal-header">
        <div className="headerContent">
          <div className="title">
            <h1>{activeCustomReport.CustomReportName}</h1>
          </div>
          {userIsAuthorized && (
            <IconButtonContainer className="actions">
              <IconButton title="Edit" onClick={() => setEditModal((prev) => !prev)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  edit
                </span>
                Edit
              </IconButton>

              <IconButton title="Duplicate" onClick={() => setDuplicateModal(true)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  content_copy
                </span>
                Duplicate
              </IconButton>

              <IconButton title="Delete" onClick={() => setDeleteToast((prev) => !prev)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  delete
                </span>
                Delete
              </IconButton>

              <div className="divider" />

              <IconButton title="Sidebar" onClick={() => setShowNavigationSidebar(!showNavigationSidebar)}>
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  view_sidebar
                </span>
                Sidebar
              </IconButton>

              <IconButton
                title={displayGrid ? 'Hide Grid' : 'Show Grid'}
                onClick={() => setDisplayGrid((prev) => !prev)}
              >
                <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>
                  {displayGrid ? 'grid_on' : 'grid_off'}
                </span>
                {displayGrid ? 'Hide Grid' : 'Show Grid'}
              </IconButton>

              <div className="divider" />

              {activeCustomReport.subcampaign[-1]?.published.DIGITAL ? (
                <>
                  <DarkButton className="publish" onClick={handleUnPublishCustomReport}>
                    Unpublish
                  </DarkButton>
                  <span className="published-date">{publishedDate}</span>
                </>
              ) : (
                <DarkButton className="publish" onClick={handlePublishCustomReport}>
                  Publish
                </DarkButton>
              )}
            </IconButtonContainer>
          )}
        </div>
        <button
          onClick={() => {
            searchParams.delete('tab');
            searchParams.delete('customReportID');
            setSearchParams(searchParams);
          }}
          className="close-btn"
          type="button"
          title="Close"
        >
          <span className="material-symbols-outlined">{closeIcon}</span>
        </button>
      </div>

      {/* Main Content Area - Always in Presentation Mode */}
      <PresentationContainer>
        {sectionLayoutState && sectionLayoutState.length > 0 ? (
          // PowerPoint-style presentation mode
          <SlideViewport>
            <SlideDisplay>
              <div className="current-slide">
                {sectionLayoutState
                  .filter((item) =>
                    !activeCustomReport?.authorized && item.SectionElements ? item.SectionElements?.length > 0 : true,
                  )
                  .sort((a, b) => (a.Position || 0) - (b.Position || 0))[currentSlideIndex] && (
                  <ReactGridLayout
                    className="layout"
                    cols={1}
                    rowHeight={739}
                    layout={[
                      {
                        i:
                          sectionLayoutState
                            .filter((item) =>
                              !activeCustomReport?.authorized && item.SectionElements
                                ? item.SectionElements?.length > 0
                                : true,
                            )
                            .sort((a, b) => (a.Position || 0) - (b.Position || 0))[currentSlideIndex]?.SectionPosition
                            ?.i || '1',
                        x: 0,
                        y: 0,
                        w: 1,
                        h: 1,
                      },
                    ]}
                    width={800}
                    style={{ width: '100%', gap: '40px', marginBottom: '40px', pointerEvents: 'initial' }}
                    isDraggable={false}
                    isResizable={false}
                    margin={[0, 100]}
                    containerPadding={[0, 0]}
                  >
                    <div
                      className="grid-section"
                      key={
                        sectionLayoutState
                          .filter((item) =>
                            !activeCustomReport?.authorized && item.SectionElements
                              ? item.SectionElements?.length > 0
                              : true,
                          )
                          .sort((a, b) => (a.Position || 0) - (b.Position || 0))[currentSlideIndex]?.Position
                      }
                      style={{
                        position: 'relative',
                        width: '100%',
                        height: 'fit-content',
                      }}
                    >
                      <CustomReportSection
                        displayGrid={displayGrid}
                        sectionDetails={structuredClone(
                          sectionLayoutState
                            .filter((item) =>
                              !activeCustomReport?.authorized && item.SectionElements
                                ? item.SectionElements?.length > 0
                                : true,
                            )
                            .sort((a, b) => (a.Position || 0) - (b.Position || 0))[currentSlideIndex],
                        )}
                        isSectionDraggable={false}
                      />
                    </div>
                  </ReactGridLayout>
                )}
              </div>
            </SlideDisplay>

            <SlideControls>
              <button
                className="icon material-symbols-outlined"
                onClick={navigatePrevious}
                disabled={currentSlideIndex === 0}
                title="Previous Section"
                type="button"
              >
                chevron_left
              </button>

              <div className="slide-indicator">
                <span className="current-slide-number">{currentSlideIndex + 1}</span>
                <span>/</span>
                <span>{sectionLayoutState.length}</span>
              </div>

              <button
                className="icon material-symbols-outlined"
                onClick={navigateNext}
                disabled={currentSlideIndex === sectionLayoutState.length - 1}
                title="Next Section"
                type="button"
              >
                chevron_right
              </button>
            </SlideControls>
          </SlideViewport>
        ) : (
          <TxtContainer
            style={{
              margin: '0',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <ReactLoading type="spinningBubbles" color={theme.publishButton} />
          </TxtContainer>
        )}

        {/* Navigation Sidebar */}
        <NavigationSidebar isVisible={showNavigationSidebar}>
          <div className="sidebar-header">
            <h3>Sections</h3>
            <button
              className="icon material-symbols-outlined"
              onClick={() => setShowNavigationSidebar(false)}
              type="button"
            >
              close
            </button>
          </div>

          <div className="sidebar-content">
            {/* Add New Section Button */}
            <div
              style={{
                padding: '16px',
                borderBottom: '1px solid ' + (theme?.border || '#ddd'),
                marginBottom: '16px',
              }}
            >
              <IconButton
                title="Add New Section"
                style={{ width: '100%', justifyContent: 'center' }}
                onClick={() => {
                  const nextPosition = getNextAvailablePosition(sectionLayoutState);
                  const newSection = {
                    position: nextPosition,
                    sectionElements: [],
                    sectionPosition: {
                      i: nextPosition.toString(),
                      x: 0,
                      y: 0,
                      w: 1,
                      h: 1,
                    },
                  };
                  console.log('NEW SECTION:', newSection);
                  saveNewSection(newSection.position, newSection.sectionPosition).then((response) => {
                    if (response === 'success') {
                      fetchCustomReportSections(activeCustomReport.CustomReportID).then((response) => {
                        if (response) {
                          safeSectionLayoutUpdate(() => response);
                        }
                      });
                    }
                  });
                }}
              >
                <div style={{ fontSize: '18px' }} className="svg material-symbols-outlined">
                  splitscreen_add
                </div>
                <span style={{ marginLeft: '8px', fontSize: '14px' }}>Add New Section</span>
              </IconButton>
            </div>

            {sectionLayoutState
              .filter((item) =>
                !activeCustomReport?.authorized && item.SectionElements ? item.SectionElements?.length > 0 : true,
              )
              .sort((a, b) => (a.Position || 0) - (b.Position || 0))
              .map((item, index) => (
                <SlideThumbnail
                  key={item.SectionID}
                  isActive={index === currentSlideIndex}
                  isDragging={draggedIndex === index}
                  isDraggedOver={dragOverIndex === index}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragEnd={handleDragEnd}
                  onClick={() => {
                    if (draggedIndex === null) {
                      navigateToSlide(index);
                    }
                  }}
                >
                  <div className="thumbnail-content">
                    <CustomReportSection
                      displayGrid={false}
                      sectionDetails={structuredClone(item)}
                      isSectionDraggable={false}
                      disableModal={true}
                    />
                  </div>

                  <div className="thumbnail-overlay">
                    <span className="slide-number">Section {index + 1}</span>
                    <div style={{ display: 'flex', gap: '4px' }}>
                      <button
                        className="action-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDuplicateSection(item);
                        }}
                        title="Duplicate Section"
                        disabled={isDuplicatingSection}
                      >
                        <span className="material-symbols-outlined">
                          {isDuplicatingSection ? 'hourglass_empty' : 'content_copy'}
                        </span>
                      </button>
                      <button
                        className="action-btn delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSectionToDelete(item.SectionID as string);
                          setShowDeleteSectionModal(true);
                        }}
                        title="Delete Section"
                      >
                        <span className="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                </SlideThumbnail>
              ))}
          </div>
        </NavigationSidebar>
      </PresentationContainer>

      {editModal && <AddCustomReport setAddCustomReportModal={setEditModal}></AddCustomReport>}
      {duplicateModal && <DuplicateCustomReportModal setDuplicateModal={setDuplicateModal} />}
      {deleteToast && (
        <div className="toast">
          <div className="toast-content">
            <p>Are you sure you want to delete this custom report?</p>
            <div className="buttons">
              <button
                onClick={() => {
                  setDeleteToast(false);
                  searchParams.delete('tab');
                  searchParams.delete('customReportID');
                  setSearchParams(searchParams);
                }}
              >
                Cancel
              </button>
              <DarkButton
                onClick={() => {
                  // Handle deletion logic here
                  handleDeleteCustomReport();
                }}
              >
                Confirm
              </DarkButton>
            </div>
          </div>
        </div>
      )}

      {showDeleteSectionModal &&
        sectionToDelete &&
        createPortal(
          <DeleteConfirmationModal
            handleDeleteConfirmationModal={(confirmed) => {
              if (confirmed && sectionToDelete) {
                handleDeleteSection(sectionToDelete);
              } else {
                setShowDeleteSectionModal(false);
                setSectionToDelete(null);
              }
            }}
            modalObject={{
              title: 'Delete Section',
              message: `Are you sure you want to delete this section? This action cannot be undone and will remove all elements within this section.${isDeletingSection ? '\n\nPlease wait...' : ''}`,
              mainButton: isDeletingSection ? 'Deleting...' : 'Delete',
              secondaryButton: isDeletingSection ? undefined : 'Cancel',
            }}
          />,
          document.body,
        )}

      {/* Duplicate Section Toast Notification */}
      {duplicateToast.show &&
        createPortal(
          <div
            style={{
              position: 'fixed',
              bottom: '80px',
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '12px 24px',
              borderRadius: '8px',
              backgroundColor: duplicateToast.type === 'success' ? '#4CAF50' : '#f44336',
              color: 'white',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 10000,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              animation: 'fadeIn 0.3s ease',
            }}
          >
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>
              {duplicateToast.type === 'success' ? 'check_circle' : 'error'}
            </span>
            {duplicateToast.message}
          </div>,
          document.body,
        )}
    </CustomReportContainer>
  );
};

export default CustomReportTab;
